import React from "react";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import { FormGroup, FormLabel } from "react-bootstrap";
import Select from "react-select";
import { hasRoleIn } from "rbac/RbacHelper";
import { customMultiSelectStyles } from "commons/styles/CustomStyles";
import { PAW_LOAD_ACCESS_PERMISSIONS } from "./PawLoad.constants";
import usePawLoadForm from "./usePawLoadForm";

const PawLoad = () => {
  const canAccessPawLoad = hasRoleIn(PAW_LOAD_ACCESS_PERMISSIONS);
  const {
    customerOptions,
    populationTypeOptions,
    clientOptions,
    selectedCustomer,
    selectedPopulationType,
    selectedClient,
    isLoadingFilters,
    isSubmitting,
    isLoadEnabled,
    loadStatusMessage,
    loadStatusType,
    handleCustomerChange,
    handlePopulationTypeChange,
    handleClientChange,
    handleLoad,
  } = usePawLoadForm();

  if (!canAccessPawLoad) {
    return null;
  }

  return (
    <Container fluid className="top-spacer">
      <Row>
        <Col md={{ span: 6, offset: 3 }}>
          <Card variant="primary">
            <Card.Header>
              <Card.Title className="text-center">
                <h4>Load Criteria</h4>
              </Card.Title>
            </Card.Header>
            <Card.Body>
              {isLoadingFilters && (
                <div className="d-flex justify-content-center mb-3">
                  <Spinner animation="border" size="sm" role="status">
                    <span className="visually-hidden">Loading filters...</span>
                  </Spinner>
                </div>
              )}

              <Row>
                <Col md={12}>
                  <FormGroup as={Row}>
                    <Col md={3}>
                      <FormLabel>
                        Customer <span style={{ color: "red" }}>*</span>
                      </FormLabel>
                    </Col>
                    <Col md={9}>
                      <Select
                        options={customerOptions}
                        value={selectedCustomer}
                        onChange={handleCustomerChange}
                        placeholder="Select Customer"
                        isClearable
                        isDisabled={isLoadingFilters}
                        styles={customMultiSelectStyles}
                      />
                    </Col>
                  </FormGroup>

                  <FormGroup className="tiny-top-spacer" as={Row}>
                    <Col md={3}>
                      <FormLabel>
                        Population Type <span style={{ color: "red" }}>*</span>
                      </FormLabel>
                    </Col>
                    <Col md={9}>
                      <Select
                        options={populationTypeOptions}
                        value={selectedPopulationType}
                        onChange={handlePopulationTypeChange}
                        placeholder={
                          selectedCustomer
                            ? "Select Population Type"
                            : "Select a Customer first"
                        }
                        isClearable
                        isDisabled={!selectedCustomer || isLoadingFilters}
                        styles={customMultiSelectStyles}
                      />
                    </Col>
                  </FormGroup>

                  <FormGroup className="tiny-top-spacer" as={Row}>
                    <Col md={3}>
                      <FormLabel>
                        Client <span style={{ color: "red" }}>*</span>
                      </FormLabel>
                    </Col>
                    <Col md={9}>
                      <Select
                        options={clientOptions}
                        value={selectedClient}
                        onChange={handleClientChange}
                        placeholder={
                          !selectedCustomer
                            ? "Select a Customer first"
                            : !selectedPopulationType
                            ? "Select a Population Type first"
                            : "Select Client"
                        }
                        isClearable
                        isDisabled={!selectedPopulationType || isLoadingFilters}
                        styles={customMultiSelectStyles}
                      />
                    </Col>
                  </FormGroup>

                  <FormGroup as={Row}>
                    <Col md={12} className="d-flex justify-content-end mt-3">
                      <Button
                        variant="secondary"
                        style={{
                          paddingLeft: "50px",
                          paddingRight: "50px",
                        }}
                        disabled={!isLoadEnabled || isSubmitting}
                        onClick={handleLoad}
                      >
                        {isSubmitting ? "Loading..." : "Load"}
                      </Button>
                    </Col>
                  </FormGroup>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          {loadStatusMessage && (
            <div
              className={`mt-3 p-3 border rounded bg-light ${
                loadStatusType === "success" ? "text-success" : "text-danger"
              }`}
            >
              {loadStatusMessage}
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default PawLoad;
